import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { pure, branch, compose, renderComponent, renderNothing } from 'recompose'
import P from 'helpers/predicates'
import * as R from 'ramda'

import {
  withGlobalRoles,
  withoutRoleProps
} from 'containers/Role/utils'

const hasAllRoles = P.isSubset
const hasNotAllRoles = R.complement(hasAllRoles)

const withRedirect = (WrappedComponent) => branch(
  ({ roles, ownRoles }) => hasNotAllRoles(ownRoles, roles),
  renderComponent(WrappedComponent),
)

const enhance = R.curry((Unauthorized, Authorized) => compose(
  withGlobalRoles,
  withRedirect(Unauthorized),
  withoutRoleProps,
  pure
)(Authorized))

export { enhance }
export default enhance(renderNothing())
